const fromDtoToKpiSelection = (dto) => ({
  id: dto?.id,
  order: dto?.order,
  label: dto?.label,
  metricType: dto?.metric_type,
  metricKey: dto?.metric_key,
  stylistId: dto?.stylist,
  category: dto?.category,
});

export default fromDtoToKpiSelection;
